<div class="clsWrapper {{ theme }}">
  <div class="chat-box" *ngIf="visible" [@fadeInOut]="visible">
    <div class="chat-box-body">
      <div class="chat-box-header">
        <div class="">
          <div class="operator-status d-none">
            {{ operator.status }}
            <span class="operator-status-online">●</span>
            <button class="chat-button-header" (click)="toggleChat()">✕</button>
          </div>
          <app-chat-avatar class="main-avatar" [image]="operator.avatar"></app-chat-avatar>
          <h3 class="operator-name d-none">
            {{ operator.name }}
          </h3>
        </div>
      </div>
      <div class="chat-box-main">
        <div class="chat-message-bottom" #bottom></div>
        <ng-container *ngFor="let message of messages">
          <div
            class="chat-message m-2 mb-4"
            [class.chat-message-received]="message.type === 'received'"
            [@fadeIn]
            [class.chat-message-sent]="message.type === 'sent'">
            <div>
              <app-chat-avatar [image]="message.from.avatar" class="chat-message-from-avatar"></app-chat-avatar>
              <div class="chat-message-text">
                {{ showMessage(message) ? message?.text?.msg : message?.text }}
                <table *ngIf="showTable(message, 'table')" class="table table-bordered" aria-describedby="showTable">
                  <thead>
                    <tr>
                      <th class="px-1 py-1" *ngFor="let head of getHeaderName(message) | keys">
                        {{ head }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let item of getColumnData(message).slice(0, 4)">
                      <td class="px-1 py-1" *ngFor="let list of item | keys">
                        {{ item[list] }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div *ngIf="showTable(message, 'table')">
                  <a href="javascript:void(0)" (click)="getChatBotInfo(message)" title="View more">View more</a>.
                </div>
                <div *ngIf="showTable(message, 'link')">
                  <button type="button" class="btn btn-primary btn-sm" (click)="downloadFile(message)">
                    <em class="pi pi-download me-1" title="Download"></em>Download</button
                  >.
                </div>
                <ul class="list-group questions mt-2" *ngIf="showTable(message, 'questions')">
                  <li
                    class="list-group-item p-2 mb-1 border border-primary"
                    role="button"
                    *ngFor="let item of getColumnData(message)"
                    (click)="raiseQuestions(item)">
                    {{ item }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="chat-message-date">
              {{ message.date | date: 'short' }}

              <span style="bottom: -6px" *ngIf="message.type === 'received' && message.question">
                <span class="thumbs">
                  <span
                    title="Like"
                    ngClass="{{ getLikeStatus(message) ? 'thumbs-up active' : 'thumbs-up' }}"
                    (click)="activeLike(message)"></span>
                  <span
                    title="Dislike"
                    ngClass="{{ getDisLikeStatus(message) ? 'thumbs-down active' : 'thumbs-down' }}"
                    (click)="activeDisLike(message)"></span>
                </span>
              </span>
            </div>
            <div class="comment mt-n1 mb-3" *ngIf="openFeedback && selectedmessage === message">
              <p>Enter your feedback here</p>
              <div class="feedback-bottom">
                <input placeholder="Type here to share your feedback" id="comment-input" type="text" maxlength="1000" />
                <div class="feedback-send" (click)="sendFeedback(message)">Send</div>
              </div>
              <span class="close-comment">
                <em
                  class="pi pi-times close-btn"
                  title="close"
                  style="width: 10px; height: 10px; vertical-align: top; font-size: 12px"
                  (click)="closeFeedback()"></em>
              </span>
            </div>
          </div>
          <div class="typing" *ngIf="spin">
            <div class="bubble">
              <div class="ellipsis one"></div>
              <div class="ellipsis two"></div>
              <div class="ellipsis three"></div>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="chat-box-footer">
        <app-chat-input
          (send)="sendMessage($event)"
          (dismiss)="toggleChat()"
          (focus)="(focus)"
          [clearSearch]="clearSearch"></app-chat-input>
      </div>
      <div class="autosuggest" *ngIf="menuList.length > 0">
        <div class="close-btn d-flex align-items-center justify-content-end mx-2 my-2">
          <a href="javascript:void(0)" class="auto-suggestions-close text-right" (click)="toggleShow()">
            <em class="pi pi-times close-btn" title="close"></em>
          </a>
        </div>
        <ul class="mb-0 mx-2">
          <li *ngFor="let item of menuList" (click)="selectMessage(item)">
            {{ item }}
          </li>
        </ul>
      </div>
    </div>
  </div>

  <button type="button" class="chat-button" (click)="toggleChat()" title="Chatbot">
    <span [@fadeIn] *ngIf="visible">
      <em class="fa fa-times"></em>
    </span>
    <span [@fadeIn] *ngIf="!visible">
      <img src="../../../../../assets/images/chat.png" width="20" alt="chat-icon" />
    </span>
  </button>
</div>
